<template>
  <!-- Default to a div, but allow override via `as` prop -->
  <!-- Set max width to 1280px | Will need to test this to see what the site looks like but starting here -->
  <component :is="as || 'div'" class="max-sm:px-6 max-xl:px-13 max-w-content mx-auto w-full">
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps<{
  as?: string; // optional: element type (div, section, main, etc.)
}>();
</script>
